import { render } from "./Login_otp.vue?vue&type=template&id=afe2c06a"
import script from "./Login_otp.vue?vue&type=script&lang=js"
export * from "./Login_otp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__